/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

const mutation = gql`
  mutation SaveSimulationRecapMutation($input: SaveSimulationRecap_M_simulation_recapInput!) {
    saveSimulationRecap_M_simulation_recap(input: $input) {
      ok
      error
      
    }
  }
`;

export default mutation;
